$(document).ready(function(){

  var siteNav = $('.site-nav');
  var toggle = $('.site-nav--toggle');
  // var blurEL = $('main, footer, .attention-banner, .performances-section');
  var blurEL = $('body');
  var mainLIspan = $('.site-nav--main-li span, .site-nav--main-li svg');

  toggle.click(function(){

    siteNav.toggleClass('active-mobile');
    blurEL.toggleClass('blur');

    return;
  });

  mainLIspan.click(function(e){

    var parent = $(this).parent();
    var activeLI = $('.active-li');

    if (parent.hasClass('active-li')) {
      parent.removeClass('active-li');
      siteNav.removeClass('active-desktop');
      if ( $('.active-mobile').length < 1 ) {
        blurEL.removeClass('blur');
      }
    } else {
      activeLI.removeClass('active-li');
      parent.addClass('active-li');
      siteNav.addClass('active-desktop');
      blurEL.addClass('blur');
    }

    return;
  });

  $('.site-nav--active-background').click(function(e){
    $('.active-li').removeClass('active-li');
    siteNav.removeClass('active-desktop');
    blurEL.removeClass('blur');
  });

  $('.accordion-header').click(function(){
    $(this).parent().toggleClass('active');
  });

  var header = $('.hero-section');
  var range = $('.hero-section').height();

  if (window.innerWidth < 800 ) {

    $(window).scroll(function(){

      if (!header.length) {
        $('.site-nav').css({ 'background': 'rgba(0,0,0,'+ 0.95 +')' });
        return null;
      }

      var scrollTop = $(this).scrollTop();
      var offset = header.offset().top;
      var height = header.outerHeight();

      var calc = ((scrollTop - offset + range) / range) - 1;
      $('.site-nav').css({ 'background': 'rgba(0,0,0,'+ calc +')' });

      if ( calc > 1 ) {
        $('.site-nav').css({ 'background': 'rgba(0,0,0,'+ 0.95 +')' });
      } else {
        $('.site-nav').css({ 'background': 'rgba(0,0,0,'+ Math.max(calc, 0.27)  +')' });
      }

      return null;

    });

  } else if ( $('.attention-nav').length ) {

    $(window).scroll(function(){
      var scrollTop = $(this).scrollTop();

      if (scrollTop > range) {
        $('.attention-nav').addClass('attention-nav---active');
      } else {
        $('.attention-nav').removeClass('attention-nav---active');
      }

      return null;
    });

  }

  $('.js-dropdown--main-option').click(function(){
    $('.series-dropdown').toggleClass('series-dropdown---active');
  });

  if ($('.performances-section .pagination').length) {

    var infiniteScroll = jQuery.ias({
      container: '.performance-blocks',
      item: '.performance-block',
      pagination: '.pagination',
      next: '.pagination--next'
    });

  }

  if ($('.experience-entry').length) {

    $('.experience-block--left, .experience-block--right').bind('inview', function (event, visible) {
      if (visible) {
        // element is now visible in the viewport
        $(this).addClass('active');
      } else {
        // element has gone out of viewport
        $(this).removeClass('active');
      }
    });

  }

  if ($('.jerusalem-gallery').length) {
    var prevButton = '<button class="slick-prev"><svg class="icon icon-down-carrot left"><use xlink:href="#icon-down-carrot"></use></svg></button>';
    var nextButton = '<button class="slick-next"><svg class="icon icon-down-carrot right"><use xlink:href="#icon-down-carrot"></use></svg></button>';

    var galleryOptions = {
      adaptiveHeight: true,
      prevArrow: prevButton,
      nextArrow: nextButton,
      zIndex : 9999
    };

    $('.jerusalem-gallery--section').slick(galleryOptions);

  }

  var heroVideoCheck =  $('.hero-section--video-wrapper, .gallery-section--video-wrapper').length;
  var iframeVideoCheck = $('.hero-section---iframe').length;

  if ( (!mobileAndTabletcheck() && heroVideoCheck) || iframeVideoCheck ) {

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    $('.gallery-image---backup').remove();

  } else if ( heroVideoCheck ) {

    $('.hero-section--video, .gallery-section--video-wrapper').remove();
    $('.hero-section').addClass('video-backup');

  }

});


function mobileAndTabletcheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

function onYouTubeIframeAPIReady() {

  var videos;
  var iframeVideos = $('.hero-section---iframe');
  var heroVideos = $('.hero-section--video-wrapper, .gallery-section--video-wrapper');

  if (mobileAndTabletcheck()) {
    videos = iframeVideos;

    heroVideos.each(function(){
      if (!$(this).hasClass('hero-section---iframe')) {
        $(this).parent().parent().addClass('video-backup');
        $(this).parent().remove();
        return;
      }
      return;
    });

  } else {
    videos = heroVideos;
  }

  var regex = 'v=([a-zA-Z0-9\_\-]+)&?';

  videos.each(function(d){

    var check = $(this).hasClass('hero-section---iframe');
    var url = $(this).data('video');
    var playerID = $(this).data('id');
    var id = url.match(regex);

    var iframeOptions = {
      'autoplay': 0,
      'controls': 1,
      'autohide': 1,
      'wmode': 'opaque',
      'showinfo': 0,
      'loop': 0,
      'mute': 0,
      'playlist': id[1]
    };

    var iframeOnReady = {
      'onReady': ''
    };

    var bvOptions = {
        'autoplay': 1,
        'controls': 0,
        'autohide': 1,
        'wmode': 'opaque',
        'showinfo': 0,
        'loop': 1,
        'mute': 1,
        'playlist': id[1]
    };

    var bvOnReady = {
      'onReady': onPlayerReady
    };

    return new YT.Player(playerID, {
      playerVars: check ? iframeOptions : bvOptions,
      videoId: id[1],
      events: check ? iframeOnReady : bvOnReady
    });

  });

}

function onPlayerReady(event) {
  event.target.mute();
  event.target.playVideo();
}
